import { render, staticRenderFns } from "./selectRegion.vue?vue&type=template&id=36200f56&scoped=true"
import script from "./selectRegion.vue?vue&type=script&lang=js"
export * from "./selectRegion.vue?vue&type=script&lang=js"
import style0 from "./selectRegion.vue?vue&type=style&index=0&id=36200f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36200f56",
  null
  
)

export default component.exports